export default __webpack_public_path__ + "static/media/angle-left-thin.57cf4dc6.svg";